var _rect, _rect2, _rect3, _rect4, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecycleBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 2,
    height: 8.66667,
    fill: "#2A83F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.66675,
    y: 6,
    width: 2.66667,
    height: 8.66667,
    fill: "#6ABC6D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 2,
    height: 8.66667,
    fill: "#F8B165"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 4,
    height: 2,
    fill: "#FEFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.2V1.6L5.75 1.6V0L10.25 0V1.6L14 1.6V3.2L2 3.2ZM6.5 1.6V0.8L9.5 0.8V1.6L6.5 1.6Z",
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 4.8L2.75 4.8L2.75 16H13.25L13.25 4.8ZM5.75 6.4H4.25L4.25 14.4H5.75L5.75 6.4ZM8.75 6.4H7.25L7.25 14.4H8.75V6.4ZM10.25 6.4H11.75L11.75 14.4H10.25L10.25 6.4Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycleBin);
export default __webpack_public_path__ + "static/media/RecycleBin.2b667eab9fbebee9a9a03a98226dc409.svg";
export { ForwardRef as ReactComponent };